import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
interface Stat {
  target?: number;
  suffix?: string;
  pad?: number;
  staticValue?: string;
  label: string;
}
function AnimatedNumber({
  target,
  suffix = '',
  pad
}: {
  target: number;
  suffix?: string;
  pad?: number;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-40px'
  });
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const duration = 1400;
    const start = performance.now();
    let frame: number;
    const tick = (now: number) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(eased * target));
      if (progress < 1) {
        frame = requestAnimationFrame(tick);
      }
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [inView, target]);
  const display = pad ? String(value).padStart(pad, '0') : String(value);
  return <span ref={ref} data-id="element-235" data-mp="3tfc3yyhdivqb">
      {display}
      {suffix}
    </span>;
}
export function StatsBar() {
  const {
    t
  } = useLanguage();
  const stats: Stat[] = [{
    target: 10,
    suffix: '+',
    label: t.stats_label1
  }, {
    target: 9,
    pad: 2,
    label: t.stats_label2
  }, {
    target: 100,
    suffix: '%',
    label: t.stats_label3
  }, {
    staticValue: '1:1',
    label: t.stats_label4
  }];
  return <section className="bg-black py-10 sm:py-16" data-id="element-236" data-mp="g80nnywr9ppv">
      <div className="container mx-auto px-4 sm:px-6" data-id="element-237" data-mp="g7sd4do3uwhu">
        <div className="grid grid-cols-2 md:grid-cols-4" data-id="element-238" data-mp="1bjfthnryt82">
          {stats.map((stat, index) => <div key={stat.label} className={`text-center px-2 sm:px-4 py-4 md:py-0 ${index >= 2 ? 'border-t border-white/[0.08] md:border-t-0' : ''} ${index % 2 !== 0 ? 'border-l border-white/[0.08]' : ''} ${index !== 0 ? 'md:border-l border-white/[0.08]' : ''}`} data-id="element-239" data-mp="69l6oorfzwu3" data-mpi={index}>
              <div className="font-heading text-3xl sm:text-4xl md:text-7xl font-black text-white" data-id="element-240" data-mp="xjfsjbuq2nyv">
                {stat.staticValue ? stat.staticValue : <AnimatedNumber target={stat.target as number} suffix={stat.suffix} pad={stat.pad} data-id="element-241" data-mp="npgt4km19iam" />}
              </div>
              <div className="text-[10px] sm:text-xs uppercase tracking-widest text-white/40 mt-1 sm:mt-2 leading-tight" data-id="element-242" data-mp="dtvrinkvmk1e">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}